"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeString = void 0;
const normalizeString = (str) => {
    let newStr = str;
    newStr = newStr.toLowerCase();
    newStr = newStr.replace(/á/g, 'a');
    newStr = newStr.replace(/é/g, 'e');
    newStr = newStr.replace(/í/g, 'i');
    newStr = newStr.replace(/ó/g, 'o');
    newStr = newStr.replace(/ú/g, 'u');
    newStr = newStr.replace(/ /g, '-');
    newStr = newStr.replace(/ñ/g, 'n');
    return newStr;
};
exports.normalizeString = normalizeString;
exports.default = exports.normalizeString;
//# sourceMappingURL=index.js.map